export const MIN_BACKGROUND_RADIUS_VW = 0;
export const MAX_BACKGROUND_RADIUS_VW = 5;
export const BACKGROUND_RADIUS_STEP = 0.1;
